import skuCard from './skuCard';
import skuPhotoDetails from './skuPhotoDetails';

const functions = {
  skuCard,
  skuPhotoDetails
};

export default functions;
